import { render } from "./ModalWriteOffTerminals.vue?vue&type=template&id=78bc36cb"
import script from "./ModalWriteOffTerminals.vue?vue&type=script&lang=js"
export * from "./ModalWriteOffTerminals.vue?vue&type=script&lang=js"

import "./ModalWriteOffTerminals.vue?vue&type=style&index=0&id=78bc36cb&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__